<template>
  <div class="ma-5 ml-3 site_content">
    <div class="flex">
      <div class="combo_section">
        {{farm.farm.name}}
      </div>

      <div class="combo_section">
        {{ getTypeName($route.params.typeCode) }}
      </div>

      <!-- {{ this.farm.farm.code }}
      {{ this.$route.params.type.code }} -->

      <datePicker
        :fr_date="fr_date" 
        :to_date="to_date" 
        @update:fr_date="updateFrDate"
        @update:to_date="updateToDate"
      />
    </div>



    <div class="mt-3">
    <div class="table-container mt-3">
      <table class="simple-table" v-if="columns.length > 0">
        <thead>
          <tr>
            <th v-for="(col, index) in columns" :key="col.key">
              {{ col.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rIndex) in raw_list" :key="rIndex">
            <td v-for="(col, cIndex) in columns" :key="col.key">
              <div class="skeleton" v-if="loading"></div>
              <div v-else>{{ row[col.key] }}</div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>

  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

// import comboFarm from "@/components/combo/farm.vue";
import datePicker from "@/components/compo/datePicker_day.vue";

export default {
  name: 'rawData',
  components:{
    datePicker
  },
  watch: {
    // 사용자가 상단 바 등에서 농장을 바꾸면(Store 변경), 세션 정보를 지워야 함
    '$store.state.farmInfo': {
      handler() {
        this.localFarm = null;
        sessionStorage.removeItem("pack_farm");
        this.refresh();
      },
      deep: true
    },
    // URL의 타입코드(송풍기 -> 포유기 등)가 바뀌면 데이터 갱신
    '$route.params.typeCode': 'refresh',
    // '$route.params.typeCode'(newCode, oldCode) {
    //   if (newCode !== oldCode) {
    //     this.refresh()
    //   }
    // },
    fr_date() {
      if (this.canRefresh()) {
        this.refresh();
      }
    },
    to_date() {
      if (this.canRefresh()) {
        this.refresh();
      }
    }
  },
  computed: {
    farm() {
      // 농장정보가 있으면 최우선
      if (this.localFarm) return this.localFarm;
      // 없으면 현재 전역 스토어의 농장 사용
      return this.$store.state.farmInfo;
    },
    typeCode() {
    return this.$route.params.typeCode
    },
    columns() {
      if (!this.headers || Object.keys(this.headers).length === 0) {
        return [];
      }

      return Object.entries(this.headers)
        // 필터링 null이나 ""
        .filter(([key, label]) => {
          return label !== null && label !== "";
        })
        .map(([key, label]) => {
          return { 
            key: key, 
            label: label 
          };
        });
    }
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 

    const savedFarm = sessionStorage.getItem("pack_farm");
    if (savedFarm) {
      this.localFarm = JSON.parse(savedFarm);
    }

    let cdate = new Date();
    this.to_date= dateUtil.format(cdate, "yyyy-MM-dd");
    let frdate = new Date(cdate.setDate(cdate.getDate() - 30));
    this.fr_date= dateUtil.format(frdate, "yyyy-MM-dd");

  },
  destroyed() {
    sessionStorage.removeItem("pack_farm");
  },
  data(){
    return {
      fr_date: "",
      to_date: "",

      headers:{},
      raw_list:[],
      
      loading:false,

      localFarm: null,
    }
  },
  methods:{
    getTypeName(code) {
      const map = {
        PC04: "로봇착유기",
        EC01: "송풍팬 (천정·회전·측면·대각)",
        EC08: "냉방기",
        AF14: "송아지 포유기",
        BI01: "발정탐지기",
        AF02: "음수관리기",
        AF13: "TMR 배합기(급이기)"
      }
      return map[code] || code
    },
    updateFrDate(date) {
      this.fr_date = date;
    },
    updateToDate(date) {
      this.to_date = date;
    },
    canRefresh() {
      return (
        this.fr_date &&
        this.to_date
      );
    },
    refresh(){
      // console.log("farm_cd" , this.farm.farm.code)
      // console.log("type" , this.$route.params.type.code)
      if (!this.farm || !this.farm.farm || !this.farm.farm.code) return;
      
      this.loading= true;
      Apis.listRawDataOfPackage({
        "farm_cd" : this.farm.farm.code,
        "type" : this.$route.params.typeCode,
        "from" : this.fr_date,
        "to" : this.to_date
      }, (res) => {
        if (res.result) { 
          // console.log(res.data)
          this.headers = res.data.headers;
          this.raw_list = res.data.raw_list;

        } else {
          this.headers = {};
          this.raw_list = [];

        }
        this.loading= false;

      }).catch((err) => {
        console.error("listRawDataOfPackage 오류", err);
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';

::v-deep .selectBox_2 .v-input__slot{
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3) !important;
  border-radius: 10px !important;
}
.selectBox_2{
  width:170px !important;
  margin-right:5px !important;
  margin-left:-25px !important; 
  margin-top:5px !important;
}
.refresh_btn{
  min-width:30px !important;
}
.table-container {
  width: 100%; 
  max-width: 100%; 
  height: 80vh;
  
  overflow: auto; 
  
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  border: 1px solid #ddd;
  background-color: white;
}

table {
  min-width: 100%; 
  
  table-layout: auto; 
  
  border-spacing: 0;
  border-collapse: separate; 
}

thead {
  position: sticky;
  top: 0;
}

thead th {
  background-color: #005B96;
  color: white;
  padding: 12px 10px;
  
  white-space: nowrap; 
  
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #004a7a;
}

tbody td {
  padding: 8px 10px;
  background-color: white;
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
  text-align: center;
  
  white-space: nowrap; 
}

tbody td:last-child, thead th:last-child {
  border-right: none;
}

.combo_section{
  padding:10px;
  border:1px solid #b8b8b8;
  border-radius: 25px;
  margin-right:5px;
  color:gray;
}
.skeleton {
  background-color: #f0f0f0;
  height: 30px;
  width: 100%;
  border-radius: 20px;
  animation: skeleton-loading 1s linear infinite alternate;
}

@keyframes skeleton-loading {
  0% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
}
@media only screen and (max-width: 768px){
  .calendar{
    height:30px !important;
  }
}
</style>